export const environment = {
  api: {
    rootUrl: 'https://api.resolve.com',
  },
  azureADB2C: {
    apiPermissionRootUrl: 'https://resolvepractice.onmicrosoft.com/client-gateway',
    authorityDomain: 'resolvepractice.b2clogin.com',
    clientId: '2de099b8-87bf-4c3a-bf47-b1d654e96aeb',
    userFlow: {
      name: 'B2C_1_SignInOnly',
      authority: 'https://resolvepractice.b2clogin.com/resolvepractice.onmicrosoft.com/B2C_1_SignInOnly',
    },
  },
  environmentType: 'prod',
  browserLogging: false,
  gtmAccountId: 'GTM-58DBJ5PT',
  production: true,
  web: {
    rootUrl: 'https://www.resolve.com'
  },
};
